interface ContentSection { type: 'paragraph' | 'heading'; text: string; }
interface ArticleBodyProps { contentSections: ContentSection[]; }

export default function ArticleBody({ contentSections }: ArticleBodyProps) {
  return (
    <section className="w-full py-12 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10 max-w-3xl mx-auto">
        <div className="flex items-center gap-2 mb-10">
          <span className="px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full font-label">深度报道</span>
        </div>
        <div className="space-y-6">
          {contentSections.map((section, idx) => {
            if (section.type === 'heading') {
              return <h2 key={idx} className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mt-10 mb-4">{section.text}</h2>;
            }
            return <p key={idx} className="text-sm md:text-base text-foreground-700 leading-relaxed">{section.text}</p>;
          })}
        </div>
      </div>
    </section>
  );
}